import {DataGrid} from '@mui/x-data-grid';


import {useState, useEffect} from "react";

import * as React from "react";

import {getContractSectionCSF} from "../../ContractSectionFilter/ContractSectionFilterClient";
import {useDispatch, useSelector} from "react-redux";
import {changeContractSectionFilter} from "../../ContractSectionFilter/contractSectionFilterSlice";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";



function WorkDashboardCSFGrid(props) {
    const [drilldownCSF, setDrilldownCSF] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [allCSFs, setAllCSFs] = useState([]);
    const [filteredCSF, setFilteredCSF] = useState([]);

    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);

    const dispatch = useDispatch();

    //https://stackoverflow.com/questions/32414308/updating-state-on-props-change-in-react-form (answer 43)
    const [selectedSection, setSelectedSection] = useState(props.selectedSection)

    // useEffect(() => {
    //     if (props.selectedSection !== selectedSection) {
    //         setSelectedSection(props.selectedSection);
    //         console.log("this is my selectedSection for filters");
    //         console.log(props.selectedSection)
    //         console.log("this is my unfiltered filters data");
    //         console.log(allCSFs);
    //         console.log("this is my filtered filters data");
    //         console.log(allCSFs.filter(allCSFs => allCSFs.contractSection.id == selectedSection));
    //         setFilteredCSF(allCSFs.filter(allCSFs => allCSFs.contractSection.id ==  props.selectedSection))
    //     }
    // }, [props.selectedSection]);


    const fetchDrilldownCSF = () =>
        getContractSectionCSF(selectorContractSectionId)

            .then(data => {
                console.log(data);
                setDrilldownCSF(data);
                setAllCSFs(data);
                setFilteredCSF(data);
            })
    useEffect(() => {
        console.log("My CSF is so far...");
        fetchDrilldownCSF();
    }, [useSelector((state) => state.contractSectionSlc.value.id)]);
    const renderContractSectionFilters2 = drilldownCSF => {
        if (drilldownCSF.length <= 0) {
            return "No Data";
        }}


    useEffect(() => {
        fetchDrilldownCSF();
        dispatch(changeContractSectionFilter({csfGridRefresh: false}));
    }, [useSelector((state) => state.contractSectionFilterSlc.value.csfGridRefresh)===true]);






    const columns = fetchDrilldownCSF => [


        {
            field: 'contractSectionId',
            headerName: 'cs',
            // renderCell: (filteredCSF) => {
            //     return <div className="rowitem">{filteredCSF.row.contractSectionId.id}</div>;},
            // description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 30,
            hide: true,
        },
        {    field: 'id',
            headerName: 'ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 60,
            hide: true,
        },
        {
            field: 'accessType',
            headerName: 'Access',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            // editable: true,
            width: 60,
        },
        {
            field: 'filteringMethod',
            headerName: 'Filtering',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 120,

        },
        {
            field: 'recordLevel',
            headerName: 'Level',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            hide: true,
            width: 60,

        },
        {
            field: 'parentFilterId',
            headerName: 'Parent',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            hide: true,
            width: 80,

        },
        {
            field: 'dataPointId',
            headerName: 'dp.id',
            //https://stackoverflow.com/questions/65592494/material-ui-datagrid-with-nested-data ANSWER 6 on page
            // renderCell: (filteredCSF) => {
            //     return <div className="rowitem">{filteredCSF.row.dataPoint.id}</div>;},
            // description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 80,
            hide: true,
        },
        {
            field: 'dataPointName',
            headerName: 'Name',
            //https://stackoverflow.com/questions/65592494/material-ui-datagrid-with-nested-data ANSWER 6 on page
            // renderCell: (filteredCSF) => {
            //     return <div className="rowitem">{filteredCSF.row.dataPoint.name}</div>;},
            // description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 250,
        },
        {
            field: 'singleValue',
            headerName: 'Single Value',
            // renderCell: (filteredCSF) => {
            //     return <div className="rowitem">{filteredCSF.row.dataPointValue.name}</div>;},
            // description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 200,
        },
        {
            field: 'fromValue',
            headerName: 'From',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 100,
        },
        {
            field: 'toValue',
            headerName: 'To',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 100,
        },
    ];




    //         .then(data => {
    //             console.log(data);
    //             setDrilldownCSF(data);
    //             setAllCSFs(data);
    //         })
    // useEffect(() => {
    //     console.log("This is working so far...");
    //     fetchDrilldownCSF();
    // }, []);
    // const renderContractSectionFilters2 = drilldownCSF => {
    //     if (drilldownCSF.length <= 0) {
    //         return "No Data";
    //     }}
    //
    // function onChange(pagination, filters, sorter, extra) {
    //     console.log('params', pagination, filters, sorter, extra);
    // }


    return (
        <div style={{ height: '40%', width: '100%' }}>
                <Box
                    //     sx={{ fontWeight: 'bold',
                    //         fontSize: 20
                    //         // fontSize: 'h1.fontSize'
                    // }}
                    // sx={{mr: 0, mb: 0, verticalAlign: 'bottom'}}
                >
                    {/*<h3 >Contract Data Points*/}
                    {/*    /!*{props.selectedSection} {selectedSection} *!/*/}
                    {/*</h3>*/}
                    <Typography sx={{ fontWeight: 'bold'
                        // htmlFontSize: 48
                        // fontsize: 48
                    }} >Dashboard Filters</Typography>
                </Box>
            <DataGrid
                style={{ height: '90%' , width: '100%' }}
                aria-label={"ContractSectionFilters2"}
                // components={{ Toolbar: GridToolbar }}
                rows={filteredCSF}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchDrilldownCSF)}
                density={"compact"}
                pageSize={30}
                rowsPerPageOptions={[30]}
                // initialState={{
                //     sorting: {
                //         sortModel: [{ field: 'ordinalNumber', sort: 'asc' }],
                //     },
                //     filter: {
                //         filterModel: {
                //             items: [
                //                 {
                //                     columnField: 'contractSectionId',
                //                     operatorValue: 'equals',
                //                     value: '1'
                //                 }],
                //         },
                //     }
                // }}
            />
        </div>


    );



}
export default WorkDashboardCSFGrid;



